<template lang="pug">
  div
    .parallax
    v-container()
      v-row(justify="center")
        v-col(cols="12" md="4" align="center")
          .title.mb-1 Food Pantry Images
          div(style="max-width:300px")            
            v-carousel(cycle width='300' delimiter-icon="mdi-circle-medium" height="200" hide-delimiter-background show-arrows-on-hover)
              v-carousel-item(v-for="(photo,i) in photos" :key="i" :src="photo", 'reverse-transition'="fade-transition" transition="fade-transition")
        v-col(cols="12" md="8")
          .headline About Us
          p.body-1 Word of Mouth Food Pantry was established approximately 10 years ago in San Francisco, California. At that time it was under the direction of Pamela Mack and Elder Freddie Kendrick. While under their direction, they served over 1,000,000 pounds of food!
          p.bodyCity of Refuge UCC moved to Oakland and present directors were none busy with other ministries.  In 2014, the pantry was re-opened under the direction of Darrell Ferrell and Mady Willie.
        v-col(cols="12")
          p.title We have a core group of regular volunteers:
          ul 
            li Vivian Sims
            li Delaney McNair
            li Lesa Gray-Magee
            li Carla Halyard
            li Carla Williams
            li Stacey Russell
            li Elizabeth Waiters
            li Katana Barnes
        v-col(cols="12")
          .title History
          p.body-1 When WOM began in Oakland, California we fed approximately 200 people. Our numbers to date has exceeded 500 people a month.  Our average is about 350 people a month. 
          p.body-1 We have developed relationships with our regular clients and learned their needs. We have held classes on healthy cooking. We have signed people up for health care through Covered California. We have had representatives come and enroll guests in Project Open Hand. Project Open Hand is a pantry that offers food to terminally ill patients. We have also given bicycles to children as well as clothing and toiletries to all. We have a standing partnership with Phytologie Wellness Center. They hold a clothing and toiletry drive for our pantry quarterly.
          p.body-1 The majority of our food is received from the Alameda County Community Foodbank. We are also part of a program called Grocery Rescue. Grocery Rescue is a program that allows us to receive groceries and items from grocery stores that would ordinarily be discarded. At this point WOM is primarily funded by the YA Flunder Foundation. 
          p.body-1 There are many ways to volunteer. We need shoppers, loaders, and folks for set up, break down, pantry organization, and distribution. We could also use a couple of grant writers.
          p.body-1 We distribute all types of food. We have meats, canned goods, milk, soups, fresh vegetables, and juices. We also have gluten free and vegan items.
          p.body-1 We serve publicly every 4th Saturday of the month. We serve parishioners every 2nd Sunday of every month. 
          p.body-1 Our set up is special. We do not give out bags of food. We allow our guests to "shop" as if they were in a grocery store. This gives the guests the opportunity the pick what they like, not what we think they should have. We are presently working on a mobile service to deliver groceries to those who have ambulatory issues. We are in need of volunteers with vehicles willing to deliver groceries to these clients.
          p.body-1 For emergency food services on non-pantry days, contact the Alameda County Community Foodbank - 510-635-3663
          p.body-1 Clients will be directed to the emergency pantry in their area when calling this number.
</template>

<script>
export default {
  data() {
    return {
      photos: [
        {
          src: require('../../assets/img/foodpantrycarousel/dsc-5280.jpg')
        },
        {
          src: require('../../assets/img/foodpantrycarousel/dsc-5286.jpg')
        },
        {
          src: require('../../assets/img/foodpantrycarousel/dsc-5287.jpg')
        },
        {
          src: require('../../assets/img/foodpantrycarousel/dsc-5291.jpg')
        },
        {
          src: require('../../assets/img/foodpantrycarousel/dsc-5292.jpg')
        },
        {
          src: require('../../assets/img/foodpantrycarousel/dsc-5293.jpg')
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.parallax
  background-image url('../../assets/img/background/900111082.png')
  height 300px
  background-attachment fixed
  background-position 0 50px
  background-repeat no-repeat
  background-size 100%
  color white
</style>
